import styled from "styled-components";
import Icon from "../../../../../components/icon";
import { theme } from "../../../../../helpers/theme";
import { ReactComponent as ResignationIconSVG } from "../../../../../assets/icons/form-info.svg";
import { useQuery } from "@tanstack/react-query";
import { getAllWarehouses } from "../../../../../services/warehouses/get-all";
import { useEffect, useMemo, useState } from "react";
import { GetAllWarehouses } from "../../../../../services/warehouses/get-all/types";
import { LoadingBackDrop } from "../../../../../components/loader";
import SessionService from "../../../../../services/session-service";

interface OfferViewWarehouseAddressProps {
    id_warehouse: string,
    id_offerta: string;

}

const address_title: string = "Adres magazynu: ";
const id_title: string = "Id magazynu: ";

export const OfferViewWarehouseAddress = ({ id_warehouse, id_offerta }: OfferViewWarehouseAddressProps) => {

    const warehouses = SessionService.getWarehousesList();

    const selectedWarehouse: GetAllWarehouses | undefined = useMemo(
        () =>
            warehouses.find(
                (item: GetAllWarehouses) => item.id_magazyn.toString() === id_warehouse
            ),
        [warehouses]
    );

    return (
        <Container>
            <IdWarehouse>
                <Span>{id_title}</Span>{id_warehouse}
            </IdWarehouse>
            {/* <OfferId>
                <Span>{"Oferta nr: "}</Span>
                {id_offerta}
            </OfferId> */}
            <AddressWarehouse>
                <Span>{address_title} </Span>
                {selectedWarehouse ?

                    `${selectedWarehouse.adres?.kraj
                        ? selectedWarehouse.adres.kraj
                        : ""} ${selectedWarehouse.adres?.wojewodztwo
                            ? selectedWarehouse.adres.wojewodztwo
                            : ""}, ${selectedWarehouse.adres?.kod_pocztowy
                                ? selectedWarehouse.adres.kod_pocztowy
                                : ""} ${selectedWarehouse.adres?.miejscowosc
                                    ? selectedWarehouse.adres.miejscowosc
                                    // : ""} ${selectedWarehouse.adres?.ulica ?
                                    //     selectedWarehouse.adres.ulica
                                    // : ""} ${selectedWarehouse.adres?.numer_budynku
                                    //     ? selectedWarehouse.adres.numer_budynku
                                    //     : ""} ${selectedWarehouse.adres?.numer_lokalu
                                    //         ? `/${selectedWarehouse.adres.numer_lokalu}`
                                    : ""} `

                    : null}

                {/* 
                Polska Pomorskie,00-123 Gdańsk ul. Obrońców Wybrzeża 1/1 */}
            </AddressWarehouse>

        </Container>
    );
};



const Container = styled.div`
display:flex;
flex-direction: column;
flex-wrap:wrap;
justify-content: flex-start;
@media (max-width:770px) and (min-width: 260px){
flex-direction: column;
};
`;

const IdWarehouse = styled.div`
display:flex;
flex-direction: row;
justify-content: flex-start;
align-items:center;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 18px;
color: ${theme.colors.gray01_secondaryText};
display:none;
`;
const OfferId = styled.div`
display:flex;
flex-direction: row;
justify-content: flex-start;
align-items:center;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 12px;
line-height: 18px;
color: ${theme.colors.gray01_secondaryText};
`
const AddressWarehouse = styled.div`
display:flex;
flex-direction: row;
justify-content: flex-start;
align-items:center;
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.gray01_secondaryText};
`;
const Span = styled.span`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
padding-right:8px;
`;
